import { lazy } from 'react';

import Loadable from 'components/Loadable';
import DefaultRouteErrorBoundary from 'components/error-boundary/DefaultRouteErrorBoundary';
import PrivateOutlet from 'routes/PrivateOutlet';
import MainLayout from 'layout/MainLayout/MainLayout';
import NavigationScroll from './NavigationScroll';

import ModuleRoutes from './Module.route';
import ComptrollerRoutes from './Comptroller.route';
import DashboardRootRoutes from './DashboardRoot.route';
import StaticSolutionRoutes from './StaticSolution.route';
import AdministrationRoutes from './Administration.route';

const SocketPlayground = Loadable(lazy(() => import('components/socket-playground/SocketPlayground')));
const NotFound = Loadable(lazy(() => import('pages/notFound/NotFound')));

const MainRoutesObject = {
	path: '/',
	element: <NavigationScroll />,
	errorElement: <DefaultRouteErrorBoundary />,
	children: [
		{
			element: <PrivateOutlet />,
			children: [
				{
					element: <MainLayout />,
					children: [
						{ path: 'socket', element: <SocketPlayground /> },
						...DashboardRootRoutes,
						...StaticSolutionRoutes,
						...AdministrationRoutes,
						...ComptrollerRoutes,
						...ModuleRoutes,
						{ path: '*', element: <NotFound /> },
					],
				},
			],
		},
	],
};
export { MainRoutesObject };
